import Vue from 'vue'
import axios from 'axios'
const vm = Vue
// axios.defaults.baseURL="http://192.168.1.188:809"
const axio = axios.create({
	baseURL: 'http://182.254.196.172:8008',
	timeout: 3000,
	header: {
		'x-client-type': 'GENERAL',
		'Content-Type': 'application/json; charset=utf-8'
	}
})
//axio.defaults.headers['Authorization']=`Bearer ${window.sessionStorage.getItem('token')}` 
 axio.interceptors.request.use((config) => { // 可使用async await 做异步操作
 	const token=`Bearer ${window.sessionStorage.getItem('token')}`;
 	config.headers = {
 		...config.headers
 	}
 	config.headers.Authorization = token

	// if ((['/Login', '/Users'].includes(config.url) && config.method === 'POST') || (["/wx"].includes(config
	// 	.url) && config.method === 'GET')) {
	// 	// console.log("不能添加token")
	// } else {

	// }
	// if ((!['/Login', '/Users'].includes(config.url) && config.method === 'POST') && !["/wx"].includes(config.url) && config.method === 'GET')) {
	// 	
	// }
	return config
}, config => { // 可使用async await 做异步操作
	return Promise.reject(config)
})



export const requestRemove = function (config) {
	return axio.request(config).then(res => {
		return res;
	}).catch(err => {
		console.log(err)
		return false;
	})
}

export const upload = function (url, filePath) {
	return new Promise((rel, rej) => {
		axio.upload(url, {
			filePath,
			name: 'file'
		}).then(res => {
			if (res.code === 200) {
				rel(res.data)
			} else {
				rej(res)
			}
		}).catch(err => {
			rej(err)
		})
	})
}

export const get = function (url, params) {
	return axio.get(url, {
		params: params
	}).then(res => {
		return res;
	}).catch(err => {
		console.log(err)
		return false;
	})
}

export const post = function (url, params) {
	return axio.post(url, params).then(res => {
		return res;
	}).catch(err => {
		console.log(err)
		return false;
	})
}

export const put = function (url, params) {
	return axio.put(url, params).then(res => {
		return res;
	}).catch(err => {
		console.log(err)
		return false;
	})
}

export const dele = function (url, params) {
	return axio.delete(url, params).then(res => {
		return res;
	}).catch(err => {
		console.log(err)
		return false;
	})
}





// WEBPACK FOOTER //
// ./src/api/index.js